export default {
  byStatus: (value, subject = 'Resource', modifier = 'created') => {
    switch (value) {
      case 200:
        switch (subject) {
          default:
            return {
              title: 'Success',
              message: subject + ' has been ' + modifier,
              type: 'success'
            }
        }
      case 201:
        switch (subject) {
          case 'Login':
            return {
              title: 'Authorization',
              message: 'Login successful',
              type: 'success'
            }
          case 'Logout':
            return {
              title: 'Authorization',
              message: 'Logout successful',
              type: 'success'
            }
          case 'Quick report':
            return {
              title: 'In progress...',
              message: 'We are generating the report, you will receive an email with instructions to download it',
              type: 'success',
              timeout: 5000
            }

          default:
            return {
              title: 'Success',
              message: subject + ' has been ' + modifier,
              type: 'success'
            }
        }
      case 400:
        switch (subject) {
          case 'Login':
            return {
              title: 'Authorization',
              message: 'Login Failed',
              type: 'error'
            }
          case 'Logout':
            return {
              title: 'Authorization',
              message: 'Logout Failed',
              type: 'error'
            }
          default:
            return {
              title: 'Bad request',
              message: subject + " hasn't been " + modifier,
              type: 'error'
            }
        }
      case 401:
        switch (subject) {
          case 'Login':
            return {
              title: 'Authorization',
              message: 'Login failed',
              type: 'error'
            }
          case 'Logout':
            return {
              title: 'Authorization',
              message: 'Logout failed',
              type: 'error'
            }
          default:
            return {
              title: 'Unauthorized',
              message: subject + " hasn't been " + modifier,
              type: 'error'
            }
        }
      case 403:
        switch (subject) {
          default:
            return {
              title: 'Forbidden',
              message: subject + " hasn't been " + modifier,
              type: 'error'
            }
        }
      case 404:
        switch (subject) {
          default:
            return {
              title: 'Not found',
              message: 'Resource not found',
              type: 'error'
            }
        }
      case 422:
        switch (subject) {
          default:
            return {
              title: 'Unprocessable entity',
              message: subject + " hasn't been " + modifier,
              type: 'error'
            }
        }
      case 500:
        switch (subject) {
          default:
            return {
              title: 'Server Error',
              message: '',
              type: 'error'
            }
        }
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/notificationsMsg.js